import { Descriptions, Modal } from 'antd';
import { formatFnfAmount } from './fnfFormatters';
import styles from './index.module.scss';

type Props = {
	isOpen: boolean;
	selectedEmployee: any;
	onCancel: () => void;
};

const formatDate = (value?: string | Date | null) => {
	if (!value) return '-';
	return new Date(value).toLocaleDateString('en-GB');
};

const formatDateTime = (value?: string | Date | null) => {
	if (!value) return '-';
	return new Date(value).toLocaleString('en-GB', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	});
};

const ViewFnfDetailsModal = ({ isOpen, selectedEmployee, onCancel }: Props) => {
	return (
		<Modal
			title="FnF Clearance Details"
			open={isOpen}
			onCancel={onCancel}
			footer={null}
			destroyOnClose
			width={560}
			rootClassName={styles['clear-fn-modal-root']}
		>
			{selectedEmployee && (
				<>
					<p style={{ marginBottom: 16 }}>
						<strong>{selectedEmployee.employeeName}</strong> (
						{selectedEmployee.employeeCode})
					</p>
					<Descriptions bordered column={1} size="small">
						<Descriptions.Item label="Last Pay Period">
							{selectedEmployee.lastPayPeriod || '-'}
						</Descriptions.Item>
						<Descriptions.Item label="Relieving Date">
							{formatDate(selectedEmployee.relievingDate)}
						</Descriptions.Item>
						<Descriptions.Item label="Leave Days">
							{selectedEmployee.leaveDays ?? '-'}
						</Descriptions.Item>
						<Descriptions.Item label="Leave Pay">
							{formatFnfAmount(
								
								selectedEmployee.leaveAmount,
								selectedEmployee.currency,
							)}
						</Descriptions.Item>
						<Descriptions.Item label="Gratuity Pay">
							{formatFnfAmount(
								selectedEmployee.gratuityAmount,
								selectedEmployee.currency,
							)}
						</Descriptions.Item>
						{selectedEmployee.fnfClearedAt && (
							<Descriptions.Item label="Cleared On">
								{formatDateTime(selectedEmployee.fnfClearedAt)}
							</Descriptions.Item>
						)}
					</Descriptions>
				</>
			)}
			{/* <div
				style={{
					display: 'flex',
					justifyContent: 'flex-end',
					marginTop: 16,
				}}
			>
				<Button
					onClick={onCancel}
					style={{
						height: 36,
						paddingInline: 20,
					}}
				>
					Close
				</Button>
			</div> */}
		</Modal>
	);
};

export default ViewFnfDetailsModal;
